export enum UtmLeadProductType {
  SEM_CHALLAN = 'SEM_CHALLAN',
  PMAX_CHALLAN = 'PMAX_CHALLAN',
  META_CHALLAN = 'META_CHALLAN',
  SEO_CHALLAN = 'SEO_CHALLAN_PAGE',
  SEM_FASTAG = 'SEM_FASTag',
  SEO_FASTAG = 'SEO_FASTag',
  WHATSAPP_WINBACK_CHALLAN = 'WHATSAPP_WINBACK_CHALLAN',
  BRANDFORMANCE_CHALLAN = 'BRANDFORMANCE_CHALLAN',
  SEM_HSRP = 'SEM_HSRP',
  SEO_HSRP = 'SEO_HSRP',
}
